import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import moment from "moment";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { AbsenceSalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { SalarieAbsenceCollectiveDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieAbsenceCollectiveDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EtatAbsencesEnum } from "../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";

@Component
export default class ModalAjoutAbsenceImposeeContrat extends Vue {
	public nouvelleAbsence: AbsenceSalarieDto | undefined;
	public nouvellesAbsences: AbsenceSalarieDto[] = [];
	public salaries: SalarieAbsenceCollectiveDto[] = [];
	public selectedSalaries: SalarieAbsenceCollectiveDto[] = [];
	public dataReady = false;
	public envoyerEMailSalaries: boolean = false;

	public init(nouvelleAbsence: AbsenceSalarieDto): void {
		this.nouvelleAbsence = nouvelleAbsence;
		this.envoyerEMailSalaries = false;
		this.fetchData();
	}

	public fetchData(): void {
		if (this.nouvelleAbsence == undefined) {
			return;
		}

		this.dataReady = false;
		ServicesFactoryInstance.SalarieService.getSalariesPourAbsenceCollective(this.nouvelleAbsence.DateDebut
			, this.nouvelleAbsence.DebutMatinAprem == "A"
			, this.nouvelleAbsence.DateFin
			, this.nouvelleAbsence.FinMatinAprem == "M"
			, data => {
				this.salaries = data;
				this.selectedSalaries = this.salaries;
				this.doSort();
				this.dataReady = true;
			});
	}

	public doSort(): void {
		this.salaries.sort(function(a, b) {
			if (a.FullName != undefined && b.FullName != undefined) {
				if (a.FullName > b.FullName) {
					return 1;
				}
				if (a.FullName < b.FullName) {
					return -1;
				}
			}

			return 0;
		});
	}

	public ischecked(idSalarie: any): boolean {
		const salarie = this.selectedSalaries.filter(x => x.IdSalarie == idSalarie)[0];

		return salarie != undefined;
	}

	public selectAll($event: any): void {
		if ($event.target.checked) {
			this.selectedSalaries = this.salaries;
		} else {
			this.selectedSalaries = [];
		}
	}

	public select($event: any, salarie: SalarieAbsenceCollectiveDto): void {
		if ($event.target.checked) {
			this.selectedSalaries.push(salarie);
		} else {
			this.selectedSalaries = this.selectedSalaries.filter(selectedSalarie => selectedSalarie.IdSalarie != salarie.IdSalarie);
		}
	}

	public cancel(): void {
		$("#modalAjoutAbsenceImposeeContrat").modal("hide");
	}

	public save(): void {
		this.nouvellesAbsences = [];

		if (this.nouvelleAbsence == undefined) {
			return;
		}

		if (this.selectedSalaries.length < 1) {
			NotificationServiceInstance.SendFailed("Veuillez sélectionner au moins un salarié");

			return;
		}

		for (let i = 0; i < this.selectedSalaries.length; i++) {
			this.nouvellesAbsences.push({
				Id: this.nouvelleAbsence.Id,
				IdSalarie: this.selectedSalaries[i].IdSalarie,
				IdContrat: this.selectedSalaries[i].IdContrat,
				DateDebut: moment.utc(this.nouvelleAbsence.DateDebut).toDate(),
				DateFin: moment.utc(this.nouvelleAbsence.DateFin).toDate(),
				DebutMatinAprem: this.nouvelleAbsence.DebutMatinAprem,
				FinMatinAprem: this.nouvelleAbsence.FinMatinAprem,
				LibelleBulletin: this.nouvelleAbsence.LibelleBulletin,
				CodeTypeAbsence: this.nouvelleAbsence.CodeTypeAbsence,
				Couleur: this.nouvelleAbsence.Couleur,
				NombreHeures: this.nouvelleAbsence.NombreHeures,
				NombreJours: this.nouvelleAbsence.NombreJours,
				NombreMois: this.nouvelleAbsence.NombreMois,
				CodeMotifReprises: this.nouvelleAbsence.CodeMotifReprises,
				DateDernierTravaille: moment.utc(this.nouvelleAbsence.DateDernierTravaille).toDate(),
				DateRepriseReelle: moment.utc(this.nouvelleAbsence.DateRepriseReelle).toDate(),
				Subrogation: this.nouvelleAbsence.Subrogation,
				SubrogationDebut: moment.utc(this.nouvelleAbsence.SubrogationDebut).toDate(),
				SubrogationFin: moment.utc(this.nouvelleAbsence.SubrogationFin).toDate(),
				Imposee: this.nouvelleAbsence.Imposee,
				Etat: EtatAbsencesEnum.Valide
			});
		}

		ServicesFactoryInstance.AbsencesService.EnregistrerAbsenceCollective(this.nouvellesAbsences, this.envoyerEMailSalaries, () => {
			this.$emit("enregistrementOk");
			NotificationServiceInstance.SendSuccess(`L'absence collective du ${this.nouvelleAbsence!.DateDebut.toLocaleDateString()} au ${this.nouvelleAbsence!.DateFin.toLocaleDateString()} a été ajoutée au planning !`);
			this.cancel();
		});
	}

	public toggleEnvoiEMail(): void {
		this.envoyerEMailSalaries = !this.envoyerEMailSalaries;
	}
}



// WEBPACK FOOTER //
// ./src/components/planningAbsences/modalAjoutAbsenceImposeeContrat/modalAjoutAbsenceImposeeContrat.ts